import React, { useCallback, useEffect, useState } from 'react';
import './legend.css';
import { DownIcon, UpIcon } from '../components/icons';
import { Logo } from '../components/logo';
export const Legend = ({ mapColourScaleDefinitions, mapColourScale, onMapColourScale }) => {
    var _a;
    const [collapseList, setCollapseList] = useState(false);
    const handleToggle = useCallback(() => {
        setCollapseList(!collapseList);
    }, [collapseList]);
    const onResize = useCallback(({ target }) => {
        setCollapseList((target.outerHeight < 670 || target.outerWidth < 768));
    }, []);
    useEffect(() => {
        window.addEventListener('resize', onResize);
        if (window === null || window === void 0 ? void 0 : window.outerHeight) {
            // if we're in the browser, pass in as though from event to initialise
            onResize({ target: window });
        }
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, [onResize]);
    const legendConfig = (_a = mapColourScaleDefinitions.find(def => def.mapStyle === mapColourScale)) === null || _a === void 0 ? void 0 : _a.legend;
    const { title = undefined, elements = [], description = undefined, disclaimer = undefined } = legendConfig !== null && legendConfig !== void 0 ? legendConfig : {};
    return (React.createElement("div", { className: "map-legend" },
        React.createElement(Logo, { variant: "default" }),
        mapColourScaleDefinitions.length > 1 ?
            React.createElement("select", { className: 'style-select', onChange: e => onMapColourScale(e.target.value), value: mapColourScale }, mapColourScaleDefinitions.map(def => React.createElement("option", { key: def.mapStyle, value: def.mapStyle }, def.legend.title))) :
            title && React.createElement("h4", { className: "h4" }, title),
        elements.length > 0 &&
            React.createElement("button", { className: "expander-button btn btn-sm", type: "button", onClick: handleToggle }, collapseList ?
                React.createElement(UpIcon, null) :
                React.createElement(DownIcon, null)),
        description && React.createElement("p", null, description),
        elements.length === 0 ?
            (disclaimer ? React.createElement("ul", { className: collapseList ? 'collapse data-legend' : 'data-legend' },
                React.createElement("p", { className: 'legend-disclaimer' }, disclaimer)) : null) :
            React.createElement("ul", { className: collapseList ? 'collapse data-legend' : 'data-legend' },
                disclaimer && React.createElement("p", { className: 'legend-disclaimer' }, disclaimer),
                elements.map((item) => {
                    var _a;
                    let key, content;
                    if ('subtitle' in item) {
                        key = item.subtitle;
                        content = React.createElement("h6", null, item.subtitle);
                    }
                    else {
                        key = `${item.text}-${item.color}`;
                        const symbol = (_a = item.symbol) !== null && _a !== void 0 ? _a : 'swatch';
                        let keyStyle;
                        if (item.hatch) {
                            keyStyle = {
                                backgroundImage: `repeating-linear-gradient(
                                                -45deg,
                                                transparent,
                                                transparent 2px,
                                                ${item.color} 2px,
                                                ${item.color} 3.5px
                                            )`,
                                backgroundColor: 'transparent',
                                border: `1.5px solid ${item.color}`,
                                borderRadius: 0,
                                width: '16px',
                                height: '16px',
                            };
                        }
                        else if (symbol === 'dashed-line') {
                            keyStyle = {
                                background: 'transparent',
                                border: 'none',
                                borderTop: `3px dashed ${item.color}`,
                                width: '22px',
                                height: 0,
                                marginTop: '6px',
                                borderRadius: 0,
                            };
                        }
                        else if (symbol === 'solid-line') {
                            keyStyle = {
                                background: 'transparent',
                                border: 'none',
                                borderTop: `2px solid ${item.color}`,
                                width: '22px',
                                height: 0,
                                marginTop: '6px',
                                borderRadius: 0,
                            };
                        }
                        else {
                            // Default + former 'circle' symbols: solid colour boxes
                            keyStyle = { background: item.color, border: item.border, borderRadius: 0 };
                        }
                        content = React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "key", style: keyStyle }),
                            item.text);
                    }
                    return (React.createElement("li", { key: key }, content));
                }))));
};
